import { render, staticRenderFns } from "./CmgSustainabilityInfo.vue?vue&type=template&id=21795006&scoped=true&lang=pug&"
import script from "./cmg-sustainability-info.ts?vue&type=script&lang=ts&"
export * from "./cmg-sustainability-info.ts?vue&type=script&lang=ts&"
import style0 from "./CmgSustainabilityInfo.vue?vue&type=style&index=0&id=21795006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21795006",
  null
  
)

export default component.exports